import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

export const baseReviewsSchema = defineSchema({
  fields: {
    discountCode: {
      dataType: "Maybe Text",
      documentation: "The discount code to shared with the customer.",
    },
    emailAddress: {
      dataType: "Email",
      documentation: "The email address of the customer.",
    },
    customerName: {
      dataType: "Name",
      documentation: "The name of the customer.",
    },
    redoCustomerId: {
      dataType: "Text",
      documentation: "The Redo customer ID.",
      hideFromInsertionModal: true,
      hideFromConditionStep: true,
    },
  },
});

export const exampleBaseReviewsSchemaInstance: SchemaInstance<
  typeof baseReviewsSchema
> = {
  discountCode: "DISCOUNT-CODE",
  emailAddress: "test@test.com",
  customerName: "John Doe",
  redoCustomerId: "65f9d2d37fd7c5a1d2c19876",
};

export function createBaseReviewSchemaInstance(
  discountCode: string | undefined,
  emailAddress: string,
  customerName: string,
  redoCustomerId: string,
): SchemaInstance<typeof baseReviewsSchema> {
  return { discountCode, emailAddress, customerName, redoCustomerId };
}
